export const PRIMARY_HEX = "#163391";

export const PRIMARY_PALETTE = {
  DEFAULT: PRIMARY_HEX,
  100: "#e9eefc",
  500: PRIMARY_HEX,
  600: "#142f85",
  700: "#0f2568",
};
